// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/RightSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var RightSquareOutlined = function RightSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareOutlinedSvg
  }));
};

RightSquareOutlined.displayName = 'RightSquareOutlined';
export default React.forwardRef(RightSquareOutlined);